import TagId from '~/constants/common/TagId';
import type { AppliedFilters } from '~/contracts/common';
import useIsInPriceDropSuppressionExperiment from '~/hooks/common/experiments/useIsInPriceDropSuppressionExperiment';
import useGetVehicles from '~/hooks/home/services/useGetVehicles';

const priceDropFilter: Partial<AppliedFilters> = {
  tagIds: [String(TagId.PriceDrop)]
};

export default function useGetPriceDropVehicles() {
  const isInPriceDropSuppressionExperiment =
    useIsInPriceDropSuppressionExperiment();

  return useGetVehicles(
    priceDropFilter,
    !isInPriceDropSuppressionExperiment,
    'Price Drop Vehicles'
  );
}
